import type { Asociado } from '@lib/types';
import { isValidEmail, validarCelularTitular } from '@lib/validators';

/**
 * Campos editables de un asociado (orden + label) compartidos por el editor de
 * filas del padrón (EditAsociadoModal) y el de resolución de observaciones
 * (ResolverObservacionModal). Vive en su propio módulo para no mezclar exports
 * de constantes/funciones con componentes (react-refresh/only-export-components).
 */
export const FIELDS: Array<{ key: keyof Asociado; label: string; placeholder?: string }> = [
  { key: 'legajo', label: 'Legajo' },
  { key: 'parentesco', label: 'Parentesco' },
  { key: 'apellSolt', label: 'Apellido' },
  { key: 'nombres', label: 'Nombres' },
  { key: 'fechaNacimiento', label: 'Fecha Nacimiento', placeholder: 'dd/mm/aaaa' },
  { key: 'nacionalidad', label: 'Nacionalidad' },
  { key: 'sexo', label: 'Sexo' },
  { key: 'estadoCivil', label: 'Estado civil' },
  { key: 'tipoDoc', label: 'Tipo de documento' },
  { key: 'documento', label: 'Documento' },
  { key: 'cuil', label: 'CUIL' },
  { key: 'domicilio', label: 'Domicilio' },
  { key: 'numero', label: 'Número' },
  { key: 'piso', label: 'Piso' },
  { key: 'depto', label: 'Depto' },
  { key: 'cp', label: 'CP' },
  { key: 'areaCelular', label: 'Área celular' },
  { key: 'numeroCelular', label: 'Número celular' },
  { key: 'email', label: 'E-mail' },
];

/**
 * Reglas extra que aplican solo cuando el asociado editado es titular:
 * email obligatorio. Celular es opcional pero, si viene, debe estar
 * completo (validarCelularTitular acepta ambos vacíos como OK).
 */
export function validarFormTitular(form: Record<string, string>): Record<string, string> {
  const errores: Record<string, string> = {};
  const email = (form.email ?? '').trim();
  if (!email) errores.email = 'El email es obligatorio para el titular';
  else if (!isValidEmail(email)) errores.email = 'Email inválido';

  const valCel = validarCelularTitular(form.areaCelular ?? '', form.numeroCelular ?? '');
  if (valCel.ok) return errores;
  if (valCel.errorArea) errores.areaCelular = valCel.errorArea;
  if (valCel.errorNumero) errores.numeroCelular = valCel.errorNumero;
  if (valCel.errorGenerico && !errores.areaCelular && !errores.numeroCelular) {
    errores.numeroCelular = valCel.errorGenerico;
  }
  return errores;
}
